import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Taskmaster, TaskmasterData } from '../../../interfaces/masters/taskmaster';
import { TaskmasterApi } from '../api/taskmaster.api';
@Injectable()
export class TaskMasterService extends TaskmasterData {

  constructor(private api: TaskmasterApi) { 
    super();
  }
  list(): Observable<Taskmaster[]> {
    return this.api.list();
  }
  taskList(): Observable<any[]> {
    return this.api.list();
  }

  getById(url:string): Observable<Taskmaster>{
      return this.api.getById(url);
  }

  create(url: string, data:Taskmaster): Observable<Taskmaster> {
    return this.api.add(url,data);
  }

  update(url: string, data:Taskmaster): Observable<Taskmaster> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
